import React from "react";
import { FormattedHTMLMessage } from "react-intl";

import { getSsoContent } from "../../lib/utils/stepComponentHelpers/stepComponentHelpers";
import { SSOResponse, VerificationService } from "../../lib/types/types";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";

import { SingleSignOnComponent } from "../SingleSignOnComponent";

interface StepSSOProps {
  verificationService: VerificationService;
}

export const ssoMessages = {
  title: (
    <FormattedHTMLMessage
      id="step.sso.title"
      defaultMessage="Verify using your school credentials"
      tagName="h1"
    />
  ),
  subtitle: (
    <FormattedHTMLMessage
      id="step.sso.subtitle"
      defaultMessage="Please sign in to your school's web portal. It will open in a new tab."
    />
  ),
  login: <FormattedHTMLMessage id="step.sso.login" defaultMessage="Sign in to my school" />,
  cancel: <FormattedHTMLMessage id="step.sso.cancel" defaultMessage="Upload Proof of Enrollment" />,
  subtitle2: (
    <FormattedHTMLMessage id="step.sso.subtitle2" defaultMessage="Can't sign in to your school?" />
  ),
};

export const reclaimMessages = {
  title: (
    <FormattedHTMLMessage
      id="step.reclaim.title"
      defaultMessage="Verify using details from your academic institution"
      tagName="h1"
    />
  ),
  subtitle: (
    <ul>
      <li>
        <FormattedHTMLMessage
          id="step.reclaim.reclaimInfo.login"
          defaultMessage="Your academic institution's portal will open for you to verify using your login information"
        />
      </li>
      <li>
        <FormattedHTMLMessage
          id="step.reclaim.reclaimInfo.review"
          defaultMessage="Review the information about you gathered in order to complete your verification"
        />
      </li>
      <li>
        <FormattedHTMLMessage
          id="step.reclaim.reclaimInfo.consent"
          defaultMessage="Provide your consent to share this information with SheerID"
        />
      </li>
    </ul>
  ),
  login: <FormattedHTMLMessage id="step.reclaim.login" defaultMessage="Verify my status" />,
  cancel: (
    <FormattedHTMLMessage id="step.reclaim.cancel" defaultMessage="Upload Proof of Enrollment" />
  ),
  subtitle2: (
    <FormattedHTMLMessage id="step.reclaim.alternative" defaultMessage="Unable to sign in?" />
  ),
  legal: (
    <FormattedHTMLMessage
      id="step.reclaim.legal"
      defaultMessage="Your login credentials and private data stay secure and are never visible with SheerID. We will always ask consent to verify.<br><br>By proceeding, you affirm that you are using your own validly issued login credentials, and that you are fully authorized to access the website using third-party technologies and to collect information from the website for verification purposes."
    />
  ),
};

const StepSSOComponent = ({ verificationService }: StepSSOProps) => {
  const verificationResponse = verificationService.verificationResponse as SSOResponse;
  const { isReclaim, messages } = getSsoContent(verificationResponse);

  return (
    <SingleSignOnComponent
      verificationService={verificationService}
      stepName={VerificationStepsEnum.sso}
      messages={messages}
      isReclaim={isReclaim}
    />
  );
};
export { StepSSOComponent };
